export default function rastreio(to, from, next) {
  if(to.fullPath === '/rastreio' || to.fullPath === '/r') {
    window.location.href = "https://soudealgodao.com.br/souabr/"
  }
  return next()
}